import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";

import { CommonState } from "../state";

import { ACTION_PREFIX } from "./common-content.action";
import { CommonContent, CommonContentParams, CommonContentState } from "./common-content.model";
import { getContentKey } from "./common-content.utils";

@Injectable({
	providedIn: "root",
})
export class CommonContentSelector {
	getState() {
		return (state: CommonState): CommonContentState => state.commonContent;
	}

	getByParams(params: CommonContentParams) {
		const contentKey = getContentKey(params);
		return (state: CommonState): CommonContent[] => state.commonContent.items[contentKey];
	}

	isBusy() {
		return (state: CommonState) => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}
}
